function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.93333 17.4938C3.69956 17.4934 3.47672 17.3948 3.31916 17.2221C3.1587 17.0508 3.07896 16.8192 3.09999 16.5854L3.30416 14.3404L12.7358 4.91211L15.6833 7.85877L6.25416 17.2863L4.00916 17.4904C3.98333 17.4929 3.95749 17.4938 3.93333 17.4938ZM16.2717 7.26961L13.325 4.32294L15.0925 2.55544C15.2488 2.39896 15.4609 2.31104 15.6821 2.31104C15.9033 2.31104 16.1154 2.39896 16.2717 2.55544L18.0392 4.32294C18.1956 4.47925 18.2836 4.69135 18.2836 4.91252C18.2836 5.1337 18.1956 5.3458 18.0392 5.50211L16.2725 7.26877L16.2717 7.26961Z",
  fill: "#00C4B5"
});

function SvgEditGreenPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGreenPencil);
export default __webpack_public_path__ + "static/media/editGreenPencil.a128c0af.svg";
export { ForwardRef as ReactComponent };